module.exports = __webpack_public_path__ + "static/media/canari_logo_love.5273ddf8.png";